import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import {
  FaTiktok,
  FaXTwitter,
  FaGlobe,
  FaSpotify,
  FaItunesNote,
  FaTwitch,
  FaBook,
  FaInstagram,
  FaPaypal,
  FaPatreon,
  FaShopify,
  FaReddit,
  FaRegNewspaper,
  FaGear,
} from "react-icons/fa6";
import { SiCashapp, SiAudiobookshelf, SiAirtable } from "react-icons/si";
import { IoLogoVenmo } from "react-icons/io5";
import { FcKindle } from "react-icons/fc";
import { ImMusic } from "react-icons/im";
import { MdOutlineArticle } from "react-icons/md";
import { LuAudioLines } from "react-icons/lu";
import { FaMicrophone } from "react-icons/fa";




/* ----------------------------- DATA ----------------------------- */
const LinkHub = () => {

const ThroneIcon = ({ className }) => (
  <svg
    className={className}
    viewBox="0 0 24 24"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M11.407 2.192 7.065 10.73a1.44 1.44 0 0 0 .243 1.649l4.2 4.389a.6.6 0 0 0 .867 0l4.2-4.39a1.44 1.44 0 0 0 .244-1.648l-4.343-8.538a.6.6 0 0 0-1.07 0ZM1.03 8.543l10.717 10.819a.48.48 0 0 1-.238.806l-5.355 1.186a2.4 2.4 0 0 1-2.823-1.673L.227 9.015c-.139-.478.452-.826.802-.472ZM23.02 8.482l-9.53 9.53a.48.48 0 0 0 .008.688l1.745 1.655c.156.148.346.256.553.314l1.912.535a2.4 2.4 0 0 0 2.947-1.626l3.164-10.62c.142-.477-.447-.829-.8-.476Z" />
  </svg>
);

const index = [
  {
    label: "The Midnight Catalogue",
    href: "https://airtable.com/app0J6w417kCXMRWy/shryHGlyjOMy2uPjB/tblyqypBs4cjQw2Lh/viwrvxgt9QCv2PENm",
    icon: SiAirtable,
    gaCategory: "Index",
    gaTitle: "The Midnight Catalogue",
    gaProvider: "Airtable",
  },
];

  const data = {
    creator: {
      name: "Valentina Vallay",
      tagline: "Author / Narrator / Voice Actor / Singer / Songwriter",
      logoUrl: "/media/logo.png",
    },
    links: {
      socials: [
        {
          label: "TikTok",
          href: "https://www.tiktok.com/@valentinavallay",
          icon: FaTiktok,
          gaCategory: "Social",
        },
        {
          label: "X (Twitter)",
          href: "https://x.com/valentinavallay",
          icon: FaXTwitter,
          gaCategory: "Social",
        },
        {
          label: "Instagram",
          href: "https://www.instagram.com/valentinavallay",
          icon: FaInstagram,
          gaCategory: "Social",
        },
        {
          label: "Twitch",
          href: "https://www.twitch.tv/valentinavallay",
          icon: FaTwitch,
          gaCategory: "Social",
        },
        {
          label: "Patreon",
          href: "https://www.patreon.com/valentinavallay",
          icon: FaPatreon,
          gaCategory: "Social",
        },
        {
          label: "Throne",
          href: "https://throne.com/valentinavallay",
          icon: ThroneIcon,
          gaCategory: "Social",
        },
        {
          label: "Reddit",
          href: "https://www.reddit.com/u/valentinavallay/s/3qaCF86sHR",
          icon: FaReddit,
          gaCategory: "Social",
        },
        {
          label: "Website",
          href: "https://valentinavallay.com",
          icon: FaGlobe,
          gaCategory: "Social",
        },
      ],

      payments: [
        {
          label: "Venmo",
          href: "https://venmo.com/u/valentinavallay",
          icon: IoLogoVenmo,
          gaCategory: "Payment",
        },
        {
          label: "Cash App",
          href: "https://cash.app/$Valentinavallay",
          icon: SiCashapp,
          gaCategory: "Payment",
        },
        {
          label: "PayPal",
          href: "https://www.paypal.me/ValentinaVallay",
          icon: FaPaypal,
          gaCategory: "Payment",
        },
      ],

      books: [
        {
          title: "It Ends In Blood",
          links: [
            {
              label: "Paperback",
              href: "https://valentinavallay.com/products/it-ends-in-blood-paperback",
              icon: FaBook,
              gaCategory: "Paperback",
              gaTitle: "It Ends in Blood Paperback",
              gaProvider: "Shopify",
            },
            {
              label: "Kindle",
              href: "https://www.amazon.com/Ends-Blood-Edge-Vengeance-Book-ebook/dp/B0FNSVM8L6",
              icon: FcKindle,
              gaCategory: "eBook",
              gaTitle: "It Ends in Blood eBook",
              gaProvider: "Amazon",
            },
            {
              label: "Audiobook",
              href: "https://valentinavallay.com/products/it-ends-in-blood-audiobook",
              icon: SiAudiobookshelf,
              gaCategory: "Audiobook",
              gaTitle: "It Ends in Blood Audiobook",
              gaProvider: "Shopify",
            },
          ],
        },
        {
          title: "It Begins in Us",
          sublabel: "Work in progress",
          links: [],
        },
      ],

      songs: [
        {
          title: "Stay With Me",
          gaCategory: "Song",
          links: [
            {
              label: "Listen on Spotify",
              href: "https://open.spotify.com/track/2sc3KBSeVVt1m9mvW6Vog7",
              icon: FaSpotify,
              gaCategory: "Song",
              gaTitle: "Stay With Me",
              gaProvider: "Spotify",
            },
            {
              label: "Listen on iTunes",
              href: "https://music.apple.com/us/album/stay-with-me/1841057852?i=1841057853",
              icon: FaItunesNote,
              gaCategory: "Song",
              gaTitle: "Stay With Me",
              gaProvider: "iTunes",
            },
          ],
        },
        {
          title: "Come Back to Me feat. Rick",
          gaCategory: "Song",
          links: [
            {
              label: "Listen on Spotify",
              href: "https://open.spotify.com/album/7yME1jWtEYTvHF6uRlwJ90?si=q6F1L0pNT4C4QKByPEm39A",
              icon: FaSpotify,
              gaCategory: "Song",
              gaTitle: "Come Back to Me feat. Rick",
              gaProvider: "Spotify",
            },
            {
              label: "Listen on iTunes",
              href: "https://music.apple.com/us/album/come-back-to-me-feat-rick-single/1877075589",
              icon: FaItunesNote,
              gaCategory: "Song",
              gaTitle: "Come Back to Me feat. Rick",
              gaProvider: "iTunes",
            },
          ],
        },
        {
          title: "Come Back to Me feat. EoS",
          gaCategory: "Song",
          links: [
            {
              label: "Listen on Spotify",
              href: "https://open.spotify.com/album/7s2P4D35k0XxV0dK1ZmLWJ?si=M-K08e0wT-eCxeWoB3lr5Q",
              icon: FaSpotify,
              gaCategory: "Song",
              gaTitle: "Come Back to Me feat. EoS",
              gaProvider: "Spotify",
            },
            {
              label: "Listen on iTunes",
              href: "https://music.apple.com/us/album/come-back-to-me-feat-eyes-of-suggestion-lore-version/1879337621?i=1879337622",
              icon: FaItunesNote,
              gaCategory: "Song",
              gaTitle: "Come Back to Me feat. EoS",
              gaProvider: "iTunes",
            },
          ],
        },
      ],

      press: [
        {
          title: "Press Releases",
          links: [
            {
              label: "Press release for TwitchCon",
              href: "https://press.valentinavallay.com/press/release_1/sheet.pdf",
              icon: MdOutlineArticle,
              gaCategory: "Press",
              gaTitle: "TwitchCon Press Release",
              gaProvider: "Press Release",
            },
          ],
        },
        {
          title: "Articles",
          links: [
            {
              label: "Publisher's Weekly Review",
              href: "https://www.pressreader.com/usa/publishers-weekly/20260119/283197269731426",
              icon: MdOutlineArticle,
              gaCategory: "Press",
              gaTitle: "Publisher's Weekly Review",
              gaProvider: "Article",
            },
          ],
        },
      ],
      setup: [
        {
          title: "Studio Equipment",
          links: [
            {
              label: "Microphone: Neumann TLM 103 Condenser Microphone",
              static: true,
            },
            { label: "Interface: Apollo Twin X Duo", static: true },
            { label: "DAW (Software): Twisted Wave", static: true },
            { label: "Acoustics: WhisperRoom MDL 4896 E", static: true },
            {
              label: "Headphones: Beyerdynamic DT 770 Pro (closed-back)",
              static: true,
            },
            { label: "Connection: Zoom, Discord", static: true },
          ],
        },
      ],
    },
  };

  /* -------------------------- ANALYTICS -------------------------- */
  function pushDL(payload) {
    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(payload);
    } catch (_) {}
  }

  function track(item) {
    if (!item) return;
    pushDL({
      event: "user_click",
      link_label: item.label || "",
      link_category: item.gaCategory || "",
      link_title: item.gaTitle || "",
      link_provider: item.gaProvider || "",
      link_url: item.href || "",
      page_location: window.location.href,
    });
  }

  useEffect(() => {
    pushDL({
      event: "page_view",
      page_location: window.location.href,
    });
  }, []);

  const ArrowSVG = () => (
    <svg
      className="card__arrow"
      viewBox="0 0 24 24"
      aria-hidden="true"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M7 17L17 7" />
      <path d="M7 7h10v10" />
    </svg>
  );

  function SocialCards({ socials = [], send }) {
    return (
      <>
        {socials.map((s) => {
          const Icon = s.icon;
          return (
            <a
              key={s.label}
              className="card card--social"
              href={s.href}
              target="_blank"
              rel="noreferrer noopener"
              aria-label={s.label}
              title={s.label}
              onClick={() => send?.(s)}
            >
              {Icon && <Icon className="social-icon" />}
            </a>
          );
        })}
      </>
    );
  }

  function PaymentCards({ payments = [], send }) {
    return (
      <>
        {payments.map((p) => {
          const Icon = p.icon;
          return (
            <a
              key={p.label}
              href={p.href}
              title={p.label}
              aria-label={p.label}
              className="payment-icon-wrapper"
              target="_blank"
              rel="noreferrer noopener"
              onClick={() => send?.(p)}
            >
              {Icon && <Icon className="payment-icon" />}
            </a>
          );
        })}
      </>
    );
  }

  function FlatCards({ items = [], send }) {
    return (
      <>
        {items.map((item) => {
          const Icon = item.icon;
          const sublabel = item.sublabel;
          const titleText = sublabel || "Unavailable";

          if (item.static) {
            return (
              <div key={item.label} className="card sublink-card card--static">
                {Icon && <Icon className="card__icon" />}
                <span className="card__label card__label--sublink">
                  {item.label}
                </span>
              </div>
            );
          }

          if (item.disabled) {
            return (
              <div
                key={item.label}
                className="card card--link is-disabled sublink-card"
                role="link"
                aria-disabled="true"
                tabIndex={-1}
                title={titleText}
              >
                {Icon && <Icon className="card__icon" />}
                <span className="card__label card__label--sublink">
                  {item.label}
                  {sublabel && (
                    <>
                      <br />
                      <span className="card__sublabel">{sublabel}</span>
                    </>
                  )}
                </span>
                <ArrowSVG />
              </div>
            );
          }

          return (
            <motion.a
              key={item.label}
              className="card card--link sublink-card"
              href={item.href}
              target="_blank"
              rel="noreferrer noopener"
              onClick={() => send?.(item)}
              whileHover={{ y: -2 }}
              whileTap={{ scale: 0.98 }}
              title={sublabel || undefined}
            >
              {Icon && <Icon className="card__icon" />}
              <span className="card__label card__label--sublink">
                {item.label}
                {sublabel && (
                  <>
                    <br />
                    <span className="card__sublabel">{sublabel}</span>
                  </>
                )}
              </span>
              <ArrowSVG />
            </motion.a>
          );
        })}
      </>
    );
  }


  function ExpandableGroup({
    title,
    headerIcon: HeaderIcon,
    headerSublabel,
    links = [],
    send,
    disabled = false,
  }) {
    const [open, setOpen] = useState(false);

    const safeId = String(title).trim().toLowerCase().replace(/\s+/g, "-");
    const hasLinks = Array.isArray(links) && links.length > 0;
    const isDisabled = disabled || !hasLinks;

    return (
      <div className="group">
        <button
          type="button"
          className={`group-card ${open ? "is-open" : ""} ${
            isDisabled ? "is-disabled" : ""
          }`}
          onClick={() => !isDisabled && setOpen((s) => !s)}
          aria-expanded={!isDisabled ? open : false}
          aria-controls={!isDisabled ? `group-${safeId}-links` : undefined}
          aria-disabled={isDisabled || undefined}
          disabled={isDisabled}
          data-disabled={isDisabled || undefined}
          title={isDisabled ? "Unavailable" : undefined}
        >
          {HeaderIcon && <HeaderIcon className="title-icon" />}
          <div className="group-card__text">
            <span className="group-card__title">{title}</span>
            {headerSublabel && (
              <span className="group-card__sublabel">{headerSublabel}</span>
            )}
          </div>

          {!isDisabled && (
            <span className="group-card__count" aria-hidden="true">
              {links.length}
            </span>
          )}

          {!isDisabled && (
            <svg
              className="group-card__caret"
              viewBox="0 0 24 24"
              aria-hidden="true"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <path d="M6 9l6 6 6-6" />
            </svg>
          )}
        </button>

        {!isDisabled && (
          <div
            id={`group-${safeId}-links`}
            className={`sublinks ${open ? "open" : ""}`}
          >
            <FlatCards items={links} send={send} />
          </div>
        )}
      </div>
    );
  }

  return (
    <div className="linkhub-container">
      <header className="linkhub-header">
        <motion.img
          src={data.creator.logoUrl}
          alt={`${data.creator.name} logo`}
          className="linkhub-logo"
          initial={{ scale: 0.9, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          transition={{ type: "spring", stiffness: 240, damping: 20 }}
        />

        <h1 className="linkhub-name">{data.creator.name}</h1>
        <p className="linkhub-tagline">{data.creator.tagline}</p>

        <nav className="social-links">
          <SocialCards socials={data.links.socials} send={track} />
        </nav>

        {/* <nav className="payment-links">
          <PaymentCards payments={data.links.payments} send={track} />
        </nav> */}
      </header>

      <main className="main">
        <section className="section">
          <div className="section-title">
            <LuAudioLines className="title-icon" />
            <h3>Audio Master List</h3>
          </div>

          <div className="section-grid">
            <FlatCards items={index} send={track} />
          </div>
        </section>

        <section className="section">
          <div className="section-title">
            <FaBook className="title-icon" />
            <h3>Books</h3>
          </div>

          <div className="section-grid">
            {Array.isArray(data.links.books) &&
              data.links.books.map((b) => {
                const autoDisabled = !(b.links || []).length;
                return (
                  <ExpandableGroup
                    key={b.title}
                    title={b.title}
                    headerSublabel={b.sublabel}
                    headerIcon={FaBook}
                    links={b.links || []}
                    send={track}
                    disabled={autoDisabled}
                  />
                );
              })}
          </div>
        </section>

        <section className="section">
          <div className="section-title">
            <ImMusic className="title-icon" />
            <h3>Songs</h3>
          </div>

          <div className="section-grid">
            {Array.isArray(data.links.songs) &&
              data.links.songs.map((song) => {
                const autoDisabled = !(song.links || []).length;
                return (
                  <ExpandableGroup
                    key={song.title}
                    title={song.title}
                    headerSublabel={song.sublabel}
                    headerIcon={ImMusic}
                    links={song.links || []}
                    send={track}
                    disabled={autoDisabled}
                  />
                );
              })}
          </div>
        </section>

        <section className="section">
          <div className="section-title">
            <FaRegNewspaper className="title-icon" />
            <h3>Press</h3>
          </div>

          <div className="section-grid">
            {Array.isArray(data.links.press) &&
              data.links.press.map((article) => {
                const autoDisabled = !(article.links || []).length;
                return (
                  <ExpandableGroup
                    key={article.title}
                    title={article.title}
                    headerIcon={MdOutlineArticle}
                    links={article.links || []}
                    send={track}
                    disabled={autoDisabled}
                  />
                );
              })}
          </div>
        </section>

        <section className="section">
          <div className="section-title">
            <FaGear className="title-icon" />
            <h3>My Set Up</h3>
          </div>

          <div className="section-grid">
            {Array.isArray(data.links.setup) &&
              data.links.setup.map((item) => {
                const autoDisabled = !(item.links || []).length;
                return (
                  <ExpandableGroup
                    key={item.title}
                    title={item.title}
                    headerIcon={FaMicrophone}
                    links={item.links || []}
                    send={track}
                    disabled={autoDisabled}
                  />
                );
              })}
          </div>
        </section>
      </main>

      <footer className="linkhub-footer">
        © {new Date().getFullYear()} {data.creator.name}
      </footer>
    </div>
  );
};

export default LinkHub;
